import { createSlice } from '@reduxjs/toolkit';
import { getAllReviews } from './reviews_service_syn';

const reviewsSlice = createSlice({
  name: 'reviews',
  initialState: {
    testimonials: [],
    loading: false,
    error: null,
    page: 1,
    limit: 10,
    totalReviews: 0,
  },
  reducers: {
    updatePage: (state, { payload }) => {
      state.page = payload;
    },
    updateLimit: (state, { payload }) => {
      state.limit = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllReviews.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllReviews.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.testimonials = payload.data.docs;
        state.totalReviews = payload.data.totalDocs;
      })
      .addCase(getAllReviews.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export const { updatePage, updateLimit } = reviewsSlice.actions;
export default reviewsSlice.reducer;
